import React, { Component } from 'react';

import { dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";
import { apiConstants } from "../../constants/api.constants";
import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import  CertReqFileModal  from "../modal/certfileuploadmodal";
import  CertCameraUploadModal  from "../modal/certcamerauploadmodal";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app


function buttonFormatter(cell, row,extra,index) {

   
    return (
      <div>
        <button className="btn btn-default btn-md" onClick={()=> extra.props.deleteDocumentHandler(cell)}>حذف</button>
        
        <button className="btn btn-default btn-md" onClick={()=> extra.showImage(index)}>مشاهده</button>
          
      </div>
    );
}

class CertReqDocPartial extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            photoIndex: 0,
            isOpen: false,
            images:[]
        }
        this.handlefileClick=this.handlefileClick.bind(this);
        this.handlecamClick=this.handlecamClick.bind(this);
        this.showImage=this.showImage.bind(this);
       
    }

    componentWillReceiveProps(newProps)
    {
       
    }
    handlefileClick()
    {
        const {model} = this.props;
        const {certreqId}=this.props.match.params;
        if(model)
        {
            this.refs.fileuploadmodal.openModal(model.Id);
        }else if(certreqId)
        {
            this.refs.fileuploadmodal.openModal(certreqId);
        }
        
    }
    handlecamClick()
    {
        const {model} = this.props;
        const {certreqId}=this.props.match.params;
        if(model)
        {
            this.refs.camerauploadmodal.openModal(model.Id);
        }else if(certreqId)
        {
            this.refs.camerauploadmodal.openModal(certreqId);
        }
        
    }

    showImage(index)
    {
        this.setState({
            isOpen:true,
            photoIndex:index
        })

    }
    
    render() { 


        const {model} = this.props;
        const { photoIndex, isOpen } = this.state;

        let images=[];
        if(model!=null && model.CertificationDocuments!=null)
        {
            console.log('Documentssss',model.CertificationDocuments)

            images=model.CertificationDocuments.map(item=>{
                return apiConstants.API_URL + '/File/'+ item.FileName
            })
        }

        console.log('images',images) 
        return (  

            <div>
                <CertReqFileModal ref="fileuploadmodal" {...this.props}></CertReqFileModal>       
                <CertCameraUploadModal ref="camerauploadmodal" {...this.props}></CertCameraUploadModal>  

                {isOpen && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length,
                        })
                        }
                        onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % images.length,
                        })
                        }
                    />
                )}

                <div className="row">
                    <div className="col-md-12">

                    <div className="panel panel-default">
               
                        <div className="toolbox">

                            <button type="button"  className="btn btn-default btn-sm" onClick={this.handlefileClick} ><i className="fa fa-file"></i>   ارسال فایل
                            
                            </button>

                            &nbsp;&nbsp;

                            <button type="button"  className="btn btn-default btn-sm" onClick={this.handlecamClick} ><i className="fa fa-camera"></i>   ارسال تصویر
                            
                            </button>
                        
                        </div>
                    </div>

                        <BootstrapTable data={model && model.CertificationDocuments}  striped hover
                            headerContainerClass='rightAlignStyle'
                            bodyContainerClass='rightAlignStyle'>

                            <TableHeaderColumn  isKey dataField='Id' hidden >id</TableHeaderColumn>  
                            <TableHeaderColumn dataField='FileName'  thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}   >نام فایل</TableHeaderColumn>                                 
                            
                            <TableHeaderColumn dataField='UploadDate' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ dateDataFormatter }  >تاریخ</TableHeaderColumn>
                            <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ buttonFormatter } formatExtraData={ this}></TableHeaderColumn>
                                  
                        </BootstrapTable>
                    

                    </div>           
                </div>

            </div>
  
        );
    }
}
 
export default CertReqDocPartial;